import * as moment from 'moment';
import { INITIALIZE } from './actionTypes';
import { allValidations } from '../../formik/validations';
import { allValidationsMultilanguage } from '../../formik/validations_multilanguage';
import { CheckLanguage } from '../../UI/languages/languages';
import { GetLanguageText } from '../../UI/languages/languages';

export const initializeFormAction = (session, responseData, validationValues, dbFormSpec, formId, formType) => {

    /* 
    NOTE; 
    the fields defined here must match the the fields in each section 
    in the configuration file and persisted user state.  the initialization
    process configures the initial values for the Formik library 
  
    if a section is active the fields are spread to the fields object
    if there is persisted user state it is spread to the fields object
    */

    let fields = {};
    const orgId = dbFormSpec.facility.orgId;
    const triPartiteOrg = orgId.includes('7042') || orgId.includes('7101') || orgId.includes('7239');
    let expirationDaysSpec = parseInt(dbFormSpec.ExpirationDateDays);
    let expirationDays = (!isNaN(expirationDaysSpec)) ? expirationDaysSpec : triPartiteOrg ? 365 : 180;
    const requestorIPAddress = responseData.requestorIPAddress;

    validationValues.context.organization = orgId;


    // PATIENT INFORMATION SECTION

    const patientInfoFields = formType === 'Patient' ?
        { PFName: "", PMName: "", PLName: "", PDOB: "", PDOB1: "", PEmail: "", PPhone: "", Patient_Email_Conform: "", Patient_Phone_Conform: "", PAddress1: "", PAddress2: "", PCity: "", PState: "", PZip: "", }
        :
        { PFName: "", PMName: "", PLName: "", PDOB: "", PDOB1: "", PEmail: "", PPhone: "", RepAddress1: "", RepAddress2: "", RepCity: "", RepEmail: "", RepFName: "", RepLName: "", RepMName: "", RepPhone: "", RepState: "", RepZip: "", Rep_Email_Conform: "", Rep_Phone_Conform: "", rrelationship: "", documentationProxy: "", supportingDocProxy:"" }

    // AUTHORIZATION TO RELEASE SECTION

    const authorizationToReleaseFields = {
        RName: "",
        RFName: "",
        RLName: "",
        RPhone: "",
        //  RFax: "",
        RAddress1: "",
        RAddress2: "",
        RCity: "",
        RState: "",
        RZip: "",
        discloseTo: "",
        REmail: "",
        facilityList: [],
        inputAuthorizePhysicianOffices: "",
        inputDisclosePhysicians: "",
        inputPhysicianNames: "not_applicable",
        facilityOrPhysician: "",
        //  Facility: "1006952||NCH Healthcare System",
        Facility: dbFormSpec.facility.orgId,
        disclosewhat: 1,
        Proxy: formType.includes('Patient') ? false : true,
        // Facility needs to come from the DB
    };

    // INFORMATION TO RELEASE SECTION

    const informationToReleaseFields = {
        infoToReleaseGroup: [],
        txtotherrecords: "", dosto: "", dosfrom: "", dosTo1: "", dosFrom1: "", requestPurposePdf: '', RequestPurpose: 33
    };

    // SENSITIVE INFORMATION SECTION

    const sensitiveInfoFields = {
        sensitiveInfo: ['psy', 'drug', 'HIV', 'STD', 'genetics'],
        // excludepsy: [], excludeSTD: "", excludeHIV: "", excludedrug: "", excludegenetics: "",
    };

    // DELIVERY METHODS SECTION

    const deliveryMethodFields = {
        // deliveryMethodGroup: [], 
        releasemodePdf: ""
    };

    // TODO; these dates should come from the API

    // RELEASE DATES SECTION

    const releaseDatesFields = {

        RequestDate: moment().format("MM/DD/YYYY"),
        expirationdate: moment().add(expirationDays, 'days').format("MM/DD/YYYY")
    };

    // ADDITIONAL INFO SECTION

    const additionalInfoSection = validationValues.page.form.sections.additionalInfoSection;
    const additionalInfoFields = {

        // c: responseData.sessionId,
        // RequestDate: new Date(responseData.timeCreated).toLocaleDateString(),
        // ArrivedDate: new Date(responseData.timeCreated).toLocaleDateString(),
        signdate: new Date().toLocaleDateString(),
        // typeofrequestorid: 5007,
        // expirationdate: new Date(responseData.expirationTime).toLocaleDateString(),

        // requesttype: "I am a patient requesting my medical records",
        // requesttypeid: "3006",
        // RequestTypeID: "3006",
        // TypeOfRequestorID: "5007",
        OtherNote: null,
        // MedicalAuthNoteResponse: "off",
        // MedicalAuthNote: "",
        // signtime: "",
        // FormName: "Request",
        // DupChecked: "0",
        // proxy: "False",
        // TargetOrganizationID: "",
        // sign: "True",
        // summary: "False",
        // verifierStaffName: "",
        // "disclosewhat": 1,

        // Facility: "1006952 || NCH Healthcare System",
        // PickupCDFacility: "1006952 || NCH Healthcare System",
        // PickupPrintFacility: "1006952 || NCH Healthcare System",
        // OrgState: "FL"
        c: responseData.sessionId,
        formId: responseData.formId
    }

    // SUPPORTING DOCS SECTION

    const supportingDocSec = validationValues.page.form.sections.supportingDocsSection;
    const supportingDocsFields = {
        supportingDoc: []
    }

    // const supportingdocFields = { supportingDoc: [] }

    // fields = {...fields, ...supportingdocFields}

    fields = { ...fields, ...patientInfoFields };
    fields = { ...fields, ...authorizationToReleaseFields };
    fields = { ...fields, ...informationToReleaseFields };
    fields = { ...fields, ...sensitiveInfoFields };
    fields = { ...fields, ...deliveryMethodFields };
    fields = { ...fields, ...releaseDatesFields };
    fields = { ...fields, ...additionalInfoFields };
    fields = { ...fields, ...supportingDocsFields };

    let validationSchema;
    let languageID = CheckLanguage(dbFormSpec);
    if (languageID != "default") {
        const languageText = GetLanguageText(languageID);
        validationSchema = allValidationsMultilanguage(validationValues, fields, formType, dbFormSpec, languageText);
    }
    else {
        validationSchema = allValidations(validationValues, fields, formType, dbFormSpec);
    }



    // const trueFormSpec = JSON.parse(responseData.formSpecs)

    return {
        type: INITIALIZE,
        payload: { session, fields, validationValues, validationSchema, dbFormSpec, formId, formType, requestorIPAddress }
    }
}